<script>
  import Block from './block.svelte'
  export let input = null
  export let accept = '*'
  export let blockProps = {}

  function onDrop(e) {
    e.preventDefault()
    if (e.dataTransfer.files.length <= 0) return
    input.files = e.dataTransfer.files
    input.dispatchEvent(new Event('change'))
  }

</script>


<Block 
  {...blockProps}
  cursor=pointer
  on:click={()=>input.click()}
  on:dragover={e=>e.preventDefault()}
  on:drop={onDrop}
>
  <slot></slot>
  <input 
    type='file'
    style='display:none'
    {accept}
    bind:this={input}
    on:change
  />
</Block>

